interface WhyChooseSectionProps {
  onGetQuote: () => void;
}

const reasons = [
  { icon: "ri-shield-check-line", title: "Single-Source Accountability", desc: "One team, one contract, one point of contact. Taurus manages every trade and phase so nothing falls through the cracks." },
  { icon: "ri-focus-3-line", title: "Clean, Precise Execution", desc: "No shortcuts. Every detail is coordinated and finished to a commercial standard that reflects well on your project." },
  { icon: "ri-time-line", title: "Reliable Timelines", desc: "Clear schedules set before construction starts, with consistent communication throughout — no surprises at handover." },
  { icon: "ri-building-4-line", title: "Commercial & Institutional Experience", desc: "From leasehold fit-outs to full design/build projects, Taurus brings the same rigour to every scope and scale." },
];

export default function WhyChooseSection({ onGetQuote }: WhyChooseSectionProps) {
  return (
    <section className="w-full py-28 px-6 lg:px-12" style={{ background: "#f7f6f4" }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">

          {/* Left: Image stack */}
          <div className="relative">
            <div className="w-full h-[500px] rounded-sm overflow-hidden">
              <img
                src="https://cdn.sanity.io/images/lncy278u/production/b4642a664cbb25c498205c0230877deeb8ff62ef-1000x589.jpg"
                alt="Taurus Contracting quality build"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating accent card */}
            <div className="absolute -bottom-8 -right-4 md:-right-8 w-52 h-40 rounded-sm overflow-hidden border-4 border-white hidden md:block">
              <img
                src="https://cdn.sanity.io/images/lncy278u/production/1c03e29c6056dc0133917c054c6ebb1796beada5-1000x667.jpg"
                alt="Exterior construction detail"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Label badge */}
            <div className="absolute top-6 left-6 bg-stone-900/90 backdrop-blur-sm px-4 py-2 rounded-sm">
              <span className="text-white text-xs uppercase tracking-[0.2em]" style={{ fontFamily: "'Inter', sans-serif" }}>
                Ontario Contractor
              </span>
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:pl-4">
            <span
              className="text-stone-400 text-xs uppercase tracking-[0.28em] font-medium block mb-5"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Why Taurus
            </span>
            <h2
              className="text-stone-900 font-semibold mb-10 leading-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(2.2rem, 3.5vw, 3.2rem)" }}
            >
              Why Clients Choose{" "}
              <span className="font-light italic">Taurus Contracting</span>
            </h2>

            <div className="space-y-7 mb-12">
              {reasons.map((reason, idx) => (
                <div key={idx} className="flex items-start gap-5">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-sm bg-stone-900">
                    <i className={`${reason.icon} text-white text-base`}></i>
                  </div>
                  <div>
                    <h4
                      className="text-stone-900 font-semibold text-base mb-1"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {reason.title}
                    </h4>
                    <p
                      className="text-stone-500 text-sm leading-relaxed"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {reason.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={onGetQuote}
              className="flex items-center gap-3 px-10 py-4 bg-stone-900 text-white font-semibold text-sm uppercase tracking-[0.12em] rounded-sm hover:bg-stone-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Start Your Project
              <i className="ri-arrow-right-line text-sm"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
